import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Shield } from "lucide-react";

const serviceData = {
  id: "controle",
  title: "Contrôle d'accès",
  description: "Systèmes de contrôle d'accès et anti-intrusion",
  icon: Shield,
  image: "/Controledacces.jpg", // Updated path
  longDescription: [
    "Nos solutions de contrôle d'accès offrent une sécurité optimale pour vos locaux professionnels. Nous concevons et installons des systèmes sur mesure qui répondent à vos besoins spécifiques de sécurité.",
    "De la simple gestion des accès à l'intégration de systèmes anti-intrusion sophistiqués, nous assurons la protection complète de vos installations.",
  ],
  features: [
    "Contrôle d'accès par badge",
    "Systèmes biométriques",
    "Gestion des droits d'accès",
    "Détection d'intrusion",
    "Supervision centralisée",
    "Historique des événements",
  ],
  benefits: [
    "Sécurité renforcée des accès",
    "Traçabilité complète",
    "Gestion simplifiée des autorisations",
    "Protection 24/7",
    "Installation sur mesure",
  ],
};

const ControleAcces = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default ControleAcces;
